import { TextField } from "@mui/material";
import { useState } from "react";

export interface FastFormTextFieldProps {
  id: string;
  defaultValue: string;
  onBlur: (val: string) => void;
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
  maxLength?: number;
}

export default function FastFormTextField({
  id,
  defaultValue,
  onBlur,
  disabled = false,
  multiline = false,
  rows,
  maxLength,
}: FastFormTextFieldProps) {
  const [value, setValue] = useState<string>(defaultValue);

  return (
    <TextField
      multiline={multiline}
      rows={rows}
      id={id}
      inputProps={{ maxLength: maxLength }}
      onChange={(ev) => setValue(ev.target.value)}
      onBlur={() => onBlur(value)}
      disabled={disabled}
      defaultValue={value}
    />
  );
}
